/**
 * AuditHistory Component
 * Muestra el historial de auditoría (creación y edición) de un recurso
 */

import React from 'react';
import '../styles/audit-history.css';

const AuditHistory = ({ createdBy, createdAt, editedBy, editedAt }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="audit-history">
      <h4>Historial de Auditoría</h4>
      <div className="audit-row">
        <div className="audit-item">
          <span className="audit-label">Creado por:</span>
          <span className="audit-value">
            {createdBy ? (
              <>
                <strong>{createdBy.first_name || createdBy.username}</strong>
                {createdBy.email && ` (${createdBy.email})`}
              </>
            ) : (
              '-'
            )}
          </span>
        </div>
        <div className="audit-item">
          <span className="audit-label">Fecha de Creación:</span>
          <span className="audit-value">{formatDate(createdAt)}</span>
        </div>
      </div>

      {editedBy && editedBy.id !== createdBy?.id && (
        <div className="audit-row">
          <div className="audit-item">
            <span className="audit-label">Editado por:</span>
            <span className="audit-value">
              <strong>{editedBy.first_name || editedBy.username}</strong>
              {editedBy.email && ` (${editedBy.email})`}
            </span>
          </div>
          <div className="audit-item">
            <span className="audit-label">Fecha de Edición:</span>
            <span className="audit-value">{formatDate(editedAt)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditHistory;
